import classNames from 'classnames';
import ArrowLeftIcon from '../../images/arrow-left-icon.svg';
import CloseIconSimple from '../../images/close-simple.svg';

import './NavigationBar.scss';

const NavigationBar = ({
  title,
  onGoBack,
  onClose,
  className = '',
  backTrackerProps = {},
  closeTrackerProps = {},
}) => (
  <div className={classNames('NavigationBar', className)}>
    <button
      type="button"
      className="NavigationBar__back"
      onClick={onGoBack}
      disabled={!onGoBack}
      {...backTrackerProps}
    >
      {onGoBack && (
        <img src={ArrowLeftIcon} alt="back icon" />
      )}
    </button>
    <span className="NavigationBar__title">{title}</span>
    <button
      type="button"
      className="NavigationBar__close"
      onClick={onClose}
      disabled={!onClose}
      {...closeTrackerProps}
    >
      {onClose && (
        <img src={CloseIconSimple} alt="close icon" />
      )}
    </button>
  </div>
);

export default NavigationBar;
